module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loadable', {
    attrs: {
      "loading": !!_vm.loading,
      "description": _vm.loading,
      "show-progress": _vm.isDownloading || _vm.isDeleting,
      "progress": _vm.isDownloading ? _vm.downloadProgress : _vm.deleteProgress,
      "only-hide": ""
    }
  }, [_c('model-crud', {
    ref: "crud",
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "actions": (_vm.bulk && _vm.actions) ? _vm.bulkActions : [],
      "allItemsActions": _vm.$auth.hasRole('COMPANY_ADMIN') && _vm.$store.auth.user.company && _vm.$store.auth.user.company.allowRecordingDeletion ? _vm.allItemsActions : [],
      "include": _vm.include,
      "extended": true,
      "paginating": _vm.paginating,
      "editable": false,
      "deletable": false,
      "exportable": _vm.exportable,
      "bulk": _vm.bulk && !_vm.recordingsConfirmations,
      "filtering": _vm.filtering,
      "default-order": "callDate",
      "default-order-asc": false,
      "perPage": _vm.perPage
    },
    scopedSlots: _vm._u([{
      key: "tags",
      fn: function(row) {
        return [_c('div', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.tag(row.item)
            }
          }
        }, [_vm._l((row.item.tags), function(tag) {
          return _c('v-chip', {
            key: tag._self,
            staticClass: "light-blue darken-1 white--text mx-1 tag-chip",
            style: (tag.color ? ("background-color: " + (tag.color) + " !important; border: 0 !important;") : ''),
            attrs: {
              "label": ""
            }
          }, [_vm._v("\n          " + _vm._s(tag.tagName) + "\n        ")])
        }), _vm._v(" "), (row.item.tags.length === 0) ? _c('v-btn', {
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 2)]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(_vm.isPlayable(row.item)) ? _c('div', {
          staticClass: "text-xs-right no-wrap"
        }, [(row.item.encrypted) ? _c('v-icon', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.recordingIsEncrypted')
            }),
            expression: "{ content: $t('recordings.recordingIsEncrypted') }"
          }],
          staticClass: "recording-lock"
        }, [_vm._v("lock")]) : _vm._e(), _vm._v(" "), (!_vm.recordingsConfirmations) ? [_c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.play')
            }),
            expression: "{ content: $t('recordings.play') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.play(row.item)
            }
          }
        }, [_c('v-icon', [_vm._v("play_arrow")])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.download')
            }),
            expression: "{ content: $t('recordings.download') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.download(row.item)
            }
          }
        }, [_c('v-icon', [_vm._v("get_app")])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.downloadMetadata')
            }),
            expression: "{ content: $t('recordings.downloadMetadata') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.downloadMetadata(row.item)
            }
          }
        }, [_c('v-icon', [_vm._v("attachment")])], 1), _vm._v(" "), (_vm.$store.auth.user.company && _vm.$store.auth.user.company.allowRecordingDeletion) ? _c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.delete')
            }),
            expression: "{ content: $t('recordings.delete') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.archive(row.item)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()] : [_c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.requestPlay')
            }),
            expression: "{ content: $t('recordings.requestPlay') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.request(row.item, 'PLAY')
            }
          }
        }, [_c('v-icon', [_vm._v("play_arrow")])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.requestDownload')
            }),
            expression: "{ content: $t('recordings.requestDownload') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.request(row.item, 'DOWNLOAD')
            }
          }
        }, [_c('v-icon', [_vm._v("get_app")])], 1), _vm._v(" "), (_vm.$store.auth.user.company && _vm.$store.auth.user.company.allowRecordingDeletion) ? _c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.requestDelete')
            }),
            expression: "{ content: $t('recordings.requestDelete') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.request(row.item, 'DELETE')
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()]], 2) : _vm._e(), _vm._v(" "), (!_vm.isPlayable(row.item) && !row.item.archived) ? _c('div', {
          staticClass: "text-xs-right pr-2"
        }, [_c('v-icon', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.formatReason(row.item)
            }),
            expression: "{ content: formatReason(row.item) }"
          }],
          staticClass: "recording-reason"
        }, [_vm._v("info")])], 1) : _vm._e(), _vm._v(" "), (row.item.archived) ? _c('div', {
          staticClass: "text-xs-right"
        }, [_c('v-icon', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.archived')
            }),
            expression: "{ content: $t('recordings.archived') }"
          }],
          staticClass: "recording-lock"
        }, [_vm._v("cloud")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('player', {
    ref: "player",
    attrs: {
      "record": _vm.playerRecord
    },
    on: {
      "closed": _vm.playerClosed
    }
  }), _vm._v(" "), _c('tagger', {
    ref: "tagger",
    attrs: {
      "record": _vm.taggerRecord
    },
    on: {
      "save": _vm.saveTags
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "350px",
      "scrollable": ""
    },
    model: {
      value: (_vm.showRequest),
      callback: function($$v) {
        _vm.showRequest = $$v
      },
      expression: "showRequest"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('recordings.actionRequest')))]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('recordings.requestQuestion')) + "\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "success": ""
    },
    on: {
      "click": _vm.doRequest
    }
  }, [_vm._v(_vm._s(_vm.$t('yes')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "error": ""
    },
    on: {
      "click": function($event) {
        _vm.showRequest = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('no')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7d6ec62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Records.vue
// module id = 1102
// module chunks = 1